import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import classNames from "classnames";
import * as authAction from "../../actions/authAction";
import logo from "../../assets/images/logo.svg";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Modal,
  ModalHeader,
} from "reactstrap";
import Api from "../../services/api";
import { changeIndexToNepali } from "../../utils";
import { ToastContainer, toast } from "react-toastify";
import MainLoader from "../../components/MainLoader";
import "react-toastify/dist/ReactToastify.css";
import { NavLink as RRNavLink } from "react-router-dom";
import { NavLink } from "reactstrap";
import "./style.css";
import { compose } from "redux";
import MapBox from "../../components/MapBox";
const province_data = [
  "koshi",
  "madhesh",
  "bagmati",
  "gandaki",
  "lumbini",
  "karnali",
  "Sudurpashchim",
];
class LoginContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      fy: null,
      fyList: null,
      error: "",
      dropdown: null,
      isLoading: false,
      isExpire: false,
      expireCode: "",
      loginModal: this.props.isOpen,
      provinceName: province_data[sessionStorage.getItem("provinceId") - 1],
    };
    // console.log(this.props, this.props);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onClickLogin = this.onClickLogin.bind(this);
  }

  async componentDidMount() {
    // let dropdown = await Api.getDropdown();
    this.setState({ isLoading: true });
    let fyList = await Api.getFyList();
    let currentFy = null;
    fyList.response.map((fy) => {
      if (fy.current_fiscal_year) {
        currentFy = fy.id;
      }
    });
    this.setState({ fyList: fyList.response, fy: currentFy, isLoading: false });
  }

  onEmailChange = (e) => {
    this.setState({
      email: e.target.value,
    });
  };

  onPasswordChange = (e) => {
    this.setState({
      password: e.target.value,
    });
  };

  onFyChange = (e) => {
    this.setState({
      fy: e.target.value,
    });
  };

  onClickLogin = async (e) => {
    const { email, password, fy, dropdown } = this.state;
    const { onLogin } = this.props;
    let cred = {
      email,
      password,
      fiscal_year_id: fy,
    };
    this.setState({ isLoading: true });
    if (!fy) {
      toast.error("कृपया आर्थिक वर्ष छान्नुहोस्", {
        position: toast.POSITION.TOP_CENTER,
      });
      this.setState({ isLoading: false });
      return;
    }
    let response = await Api.login(cred);
    this.setState({ isLoading: false });

    if (response.code === 423 && response.response) {
      this.setState({ isExpire: true, expireCode: response.response.id });
    } else if (response.code !== 200) {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    } else {
      // response.dropdown = dropdown;
      onLogin(cred, response);
    }
  };

  render() {
    const { provinceName, error, fyList, fy, isLoading } = this.state;
    const { user } = this.props;

    if (this.props.isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname:
              user.role_level === "ocmcm" || "qa"
                ? `${province_data[sessionStorage.getItem("provinceId")]}`
                : user.role_level === "ministry"
                ? `/selfassessmentform/${user.gnid}`
                : "",
            state: { from: this.props.location, showWelcome: true },
          }}
        />
      );
    }

    if (this.state.isExpire) {
      return (
        <Redirect
          to={{
            pathname: `/reset-password/${this.state.expireCode}`,
          }}
        />
      );
    }

    return (
      <Modal
        size="sm"
        isOpen={this.props.isOpen}
        toogle={() => this.toggle()}
        backdrop="static"
        centered
      >
        <div className="login-container">
          <div className="login-wrapper col-12">
            <button
              className="btn btn-danger close_btn"
              onClick={() => this.props.toggle()}
            >
              <i className="far fa-times"></i>
            </button>
            {/* <i className="close_icon fas fa-close"></i> */}
            <img src={logo} alt="logo" className="nav-logo-user" />

            {provinceName === "koshi" && (
              <div className="login-provence-name text-center">कोशी प्रदेश</div>
            )}

            {provinceName === "madhesh" && (
              <div className="login-provence-name text-center">मधेश प्रदेश</div>
            )}

            {provinceName === "bagmati" && (
              <div className="login-provence-name text-center">
                बाग्मती प्रदेश
              </div>
            )}

            {provinceName === "gandaki" && (
              <div className="login-provence-name text-center">
                गण्डकी प्रदेश
              </div>
            )}

            {provinceName === "lumbini" && (
              <div className="login-provence-name text-center">
                लुम्बिनी प्रदेश
              </div>
            )}

            {provinceName === "karnali" && (
              <div className="login-provence-name text-center">
                कर्णाली प्रदेश
              </div>
            )}

            {provinceName === "Sudurpashchim" && (
              <div className="login-provence-name text-center">
                सुदुरपश्चिम प्रदेश
              </div>
            )}
            <div className="login-header text-center">लगइन</div>
            <div className="login-form">
              <ToastContainer />
              {error && <div className="error-message">{error}</div>}
              <FormGroup>
                <Label for="email">प्रयोगकर्ता नाम</Label>
                <Input
                  type="text"
                  name="email"
                  placeholder="प्रयोगकर्ता नाम"
                  value={this.state.email || ""}
                  onChange={this.onEmailChange}
                />
              </FormGroup>

              <FormGroup>
                <Label for="password">पासवर्ड</Label>
                <Input
                  type="password"
                  name="password"
                  placeholder="पासवर्ड"
                  value={this.state.password || ""}
                  onChange={this.onPasswordChange}
                />
              </FormGroup>
              {/* <input type="password" name="password" className="login-password" placeholder="पासवर्ड" value={this.state.password || ""} onChange={this.onPasswordChange} /> */}
              <FormGroup>
                <Label for="selectFy">आर्थिक वर्ष छान्नुहोस्</Label>
                <Input
                  type="select"
                  name="selectFy"
                  onChange={this.onFyChange}
                  value={fy}
                >
                  <option value="" disabled>
                    आर्थिक वर्ष छान्नुहोस्
                  </option>
                  {fyList &&
                    fyList.map((fy, index) => {
                      return (
                        <option key={fy.id} value={fy.id}>
                          {fy.name}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup>
              {/* <NavLink to="/password/forgot" tag={RRNavLink}>पासवर्ड बिर्सिनुभयो?</NavLink> */}
              <span></span>
              <Button className="login-button" onClick={this.onClickLogin}>
                लगइन
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  initialValues: auth.login,
  isAuthenticated: auth.isAuthenticated,
  user: auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  onLogin: (cred, body) => {
    dispatch(authAction.setLoginCred(cred));
    dispatch(authAction.setToken(body.response.api_token));
    dispatch(authAction.setUser(body.response));
    dispatch(authAction.hasLoggedin());
  },
  onLogout: () => {
    dispatch(authAction.logout());
  },
});

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
);
export default enhance(LoginContainer);
